<template>

    <div class="question__body" :class="{ '-locked': disabled }">
        <question-title :title="title" :sub-title="subTitle" :hashelp="hashelp" :uuid="uuid" :question-index="questionIndex"></question-title>
        <self-disablable v-if="selfDisablable" :label="selfDisablable" :answer="answer.answer"></self-disablable>

        <table class="matrix-2d">
            <thead>
                <matrix-column-group :column-group="columnGroup" :span="columns.length"></matrix-column-group>
                <tr>
                    <th class="matrix__header-title matrix-2d__header-title" v-html="headerTitle"></th>
                    <th v-for="(column, index) of columns" :key="index" :class="{ 'col-locked': isColumnDisabled(column.value) }">
                        <span v-once v-html="column.label"></span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <matrix-2d-exclusive-row v-for="(choice, index) of choices" :key="index"
                    :question-index="questionIndex"
                    :choice="choice"
                    :row="choice.row"
                    :columns="columns"
                    :uukey="uukey"
                    :triggers="triggers"
                    :answer="answer.answer"
                    :disabled="disabled"
                    :disabled-columns="disabledColumns"
                    :read-only="readOnly"
                ></matrix-2d-exclusive-row>
                <matrix-other v-if="otherEnabled" :label="otherLabel" :instructions="otherInstructions" :uuid="uuid" :span="columns.length + 1" :othervalue="othervalue" :questionIndex="questionIndex"></matrix-other>
            </tbody>

        </table>
        <question-tip :questionTip="questionTip"></question-tip>
    </div>

</template>


<script>
import { questionMixin } from './mixins/question-mixin';
import { matrixMixin } from './mixins/matrix-mixin';
import { matrixColumnsMixin } from './mixins/matrix-columns-mixin';

export default {
    name: 'matrix-2d-exclusive',

    mixins:[
        questionMixin,
        matrixMixin,
        matrixColumnsMixin,
    ],

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/matrix-2d-exclusive.vue